"use client";

import { useTheme } from "./ThemeProvider";
import Icon from "./Icon";

// Plain light/dark toggle — no "system" option, no dropdown.
export default function ThemeMenu() {
  const { resolved, cycle } = useTheme();

  return (
    <button
      onClick={cycle}
      aria-label={resolved === "dark" ? "Switch to light theme" : "Switch to dark theme"}
      className="neu-btn grid place-items-center w-12 h-12 rounded-2xl text-text-muted shrink-0"
    >
      <Icon name={resolved === "dark" ? "moon" : "sun"} size={19} />
    </button>
  );
}
